import http from '../http'


export function get() {
  return http.get(`/v1/integrations`, { withCredentials: true })
  }
